import styled from 'styled-components'
import { INFOBAR_HEIGHT } from '@/v2/constants'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: ${INFOBAR_HEIGHT};
  width: 100%;
  padding: 0 20px;
  border-bottom: 1px solid ${({ theme }) => theme.primary.main};
  overflow-x: auto;
  flex-shrink: 0;

  @media (max-width: 1366px) {
    padding: 0 12px;
    gap: 12px;
  }
`

export const TabsAndButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  && a {
    max-width: 200px;
    height: 34px;
    border-color: ${({ theme }) => theme.primary.main};
  }

  @media (max-width: 1366px) {
    && a {
      max-width: 100px;
      padding: 6px 12px;
      font-size: 13px;
    }
  }
`
